export default {"src":"/_next/static/media/chevronLeft.45ce1bc5.svg","height":12,"width":8,"blurWidth":0,"blurHeight":0};